import { gql } from '@apollo/client';

/**
 * 查询转单任务状态
 * 类似 GET_PUBLISH_TASK_STATUS，用于轮询转单任务的执行状态
 */
export const GET_TRANSFER_TASK_STATUS = gql`
  query GetTransferTaskStatus($taskId: Long!) {
    getTransferTaskStatus(taskId: $taskId) {
      taskId
      status
      message
      newTaskIds
    }
  }
`;

export interface TransferTaskStatusResponse {
  getTransferTaskStatus: {
    taskId: number;
    status: 'PROCESSING' | 'COMPLETED' | 'FAILED' | 'PARTIAL_SUCCESS';
    message: string;
    newTaskIds?: number[]; // 成功创建的新任务ID列表
  };
}

export interface GetTransferTaskStatusVariables {
  taskId: number;
}

